export function isUCS2(str: string) {
    // This regex matches any surrogate pair (non-UCS2 character)
    const surrogatePairRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
    return !surrogatePairRegex.test(str);
}

const GSM_7BIT_CHARS =
    "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\x1BÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?"+
    "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";

const GSM_7BIT_EXTENDED_CHARS = "^{}\\[~]|€";

export function isGSM7(str: string) {
    for (const char of str) {
        if (
            !GSM_7BIT_CHARS.includes(char) &&
            !GSM_7BIT_EXTENDED_CHARS.includes(char)
        ) {
            return false;
        }
    }
    return true;
}